import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { App } from '@df/core/app';
import { isInViewport } from '@df/dom/fn/is-in-viewport';
import { TimeoutService } from '@df/ng/timeout.service';
import find from 'lodash-es/find';
import { Subscription, merge } from 'rxjs';

@Directive({
    selector: 'stickyHide,[stickyHide]',
    standalone: true
})
export class StickyHideDirective implements OnInit, OnDestroy {
    protected subscriptions: Subscription = new Subscription();

    update: () => void;

    constructor(
        private renderer2: Renderer2,
        private elementRef: ElementRef,
        private app: App,
        private timeoutService: TimeoutService
    ) {
        this.update = this.timeoutService.debounce(() => this._update(), 50);
    }

    isVisible = false;

    ngOnInit() {
        if (!this.app.isPlatformBrowser) {
            return;
        }

        this.subscriptions.add(merge(this.app.client.obs.scroll, this.app.client.obs.breakpoint).subscribe(() => this.update()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    private _update() {
        let shouldShow = true;

        // only process if sticky
        if (this.elementRef.nativeElement.classList.contains('is-sticky')) {
            // if any triggering section is in viewport then hide
            const inViewportSection = find(document.querySelectorAll('.element__hide-sticky-over'), (element: HTMLElement) =>
                isInViewport(element, 0)
            );

            shouldShow = !inViewportSection;
        }

        if (shouldShow !== this.isVisible) {
            this.isVisible = shouldShow;
            this.isVisible ? this.renderer2.removeClass(this.element, 'ng-hide') : this.renderer2.addClass(this.element, 'ng-hide');
        }
    }

    get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }
}
